import { ReactElement } from "react";
import Certificado from "../../../../../Models/Faturamento/Certificado";
import { useListar, useDasativar, useAtivar } from "../../../../../Services/Pessoa/CertificadoService";
import { Ordenar } from "../../../../../Utils/Ordenacao";
import { ResponsiveAntdTable } from "../../../../ResponsiveAntdTable";
import { Button, Popconfirm, Row, Space } from "antd";

interface ICertificadoTableProps {
    isDesativar?: boolean,
    isAtivar?: boolean,
    filtros?: {certificado?:Certificado}
}

export default function CertificadoTable({
    isDesativar,
    isAtivar,
    filtros
}: ICertificadoTableProps) {
    isDesativar = isDesativar ?? true;
    isAtivar = isAtivar ?? true;

    const {
        data,
        isLoading
    } = useListar({
        certificado : filtros?.certificado ?? {} as Certificado
    });

    const {
        mutate : mutateDesativar,
        isPending : isPedingDesativar
    } = useDasativar({

    });

    const {
        mutate: mutateAtivar,
        isPending: isPedingAtivar
    } = useAtivar({

    });

    return <ResponsiveAntdTable<Certificado>
        bordered
        locale={{ emptyText: 'Nenhum certificado encontrado.' }}
        dataSource={data}
        loading={isLoading || isPedingDesativar || isPedingAtivar}
        rowKey={(k) => k.codigo}
        addTitleOn="lg"
        columns={[
            {
                title: "Código",
                dataIndex: "codigo",
                sorter: (a, b) => Ordenar.Numero(a.codigo, b.codigo),
                key: "codigo"
            },
            {
                title: "Empresa",
                dataIndex: ["pessoa"],
                render: (_, certificado) => certificado.pessoa.nomeSocial == null ? certificado.pessoa.nome : certificado.pessoa.nomeSocial,
                sorter: (certificado1, certificado2) => Ordenar.String(certificado1.pessoa.nomeSocial == null ? certificado1.pessoa.nome : certificado1.pessoa.nomeSocial, certificado2.pessoa.nomeSocial == null ? certificado2.pessoa.nome : certificado2.pessoa.nomeSocial),
                key: "codPessoa"
            },
            {
                title: "Data vencimento",
                dataIndex: ["dataVencimento"],
                render: (value: Date) => value.toLocaleDateString(),
                sorter: (a, b) => Ordenar.Numero(a.codigo, b.codigo),
                key: "codPessoa"
            },
            {
                title: "Ativo",
                dataIndex: ["ativo"],
                render: (_, certificado) => <>{certificado.ativo ? "Sim" : "Não"}</>,
                sorter: (a, b) => Ordenar.Numero(a.codigo, b.codigo),
                key: "codPessoa"
            },
            {
                title: "Ações",
                render: (_, certificado) => <>
                    <Row wrap>
                        <Space size="small">
                            {isDesativar && certificado.ativo && <Popconfirm
                                title="Desativar"
                                description="Tem certeza que desja desativar este certificado."
                                onConfirm={() => {
                                    mutateDesativar(certificado.codigo);
                                }}
                            >
                                <Button
                                    type='primary'
                                    danger
                                    size='small'
                                    style={{ width: "min-content" }}
                                >
                                    Desativar
                                </Button>
                            </Popconfirm>}
                            {isAtivar && !certificado.ativo && <Popconfirm
                                title="Ativar"
                                description="Tem certeza que desja ativar este certificado."
                                onConfirm={() => {
                                    mutateAtivar(certificado.codigo);
                                }}
                            >
                                <Button
                                    type='dashed'
                                    size='small'
                                >Ativar</Button>
                            </Popconfirm>}
                        </Space>
                    </Row>
                </>,
                key: "acoes"
            }
        ]}
    />;
}